import Column from '@components/Column';
import Divider from '@components/Divider';
import styled from '@emotion/styled';
import { OrderLine } from '@models/order';
import { Fragment } from 'react';

import CartItem from './CartItem';
import EnabledItemsTitle from './EnabledItemsTitle';
import useCartItems from './hooks/useCartItems';
import SoldOutItemsTitle from './SoldOutItemsTitle';

interface Props {
    shopId: string;
    cartId: string;
}

function CartItemList({ items }: { items: OrderLine[] }) {
    return (
        <Items fullWidth
            as='section'
            spacing={6} >
            {items.map((item, index) => (
                <Fragment key={item.cartItemId}>
                    {index > 0 && (<Divider isThin/>)}
                    <CartItem item={item}/>
                </Fragment>
            ))}
        </Items>
    );
}

function CartItems({ shopId, cartId }:Props) {
    const {
        enableItemQty,
        soldOutItemQty,
        sortedEnableItems,
        sortedSoldOutItems,
        isSoldOutItemBlank,
    } = useCartItems();

    return (
        <Fragment>
            {sortedEnableItems.length > 0 && (
                <Fragment>
                    <Title>
                        <EnabledItemsTitle enableItemQty={enableItemQty} />
                    </Title>
                    <CartItemList items={sortedEnableItems}/>
                </Fragment>
            )}
            {(!isSoldOutItemBlank) && (
                <Fragment>
                    <Divider/>
                    <Title>
                        <SoldOutItemsTitle soldOutItemQty={soldOutItemQty} />
                    </Title>
                    <CartItemList items={sortedSoldOutItems}/>
                </Fragment>
            ) }
        </Fragment>
    );
}

const Title = styled.div`
    align-items: center;
    display: flex;
    min-height: 52px;
    padding: var(--spacing-2) var(--spacing-4);
    width: 100%;
`;

const Items = styled(Column)`
    padding: var(--spacing-3) var(--spacing-4) var(--spacing-5);
`;

export default CartItems;
